import { useState } from "react";
import { Zap } from "lucide-react";

import { Button } from "@/components/ui/button";

import { supabase } from "../../../lib/supabase";

export function ResetPasswordPage() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [resetSent, setResetSent] = useState(false);
  const [loading, setLoading] = useState(false);

  // useEffect(() => {
  //   // Check if we have a session with a recovery flow
  //   const checkSession = async () => {
  //     const {
  //       data: { session },
  //     } = await supabase.auth.getSession();

  //     if (!session) {
  //       // If no session, redirect to login
  //       navigate("/auth/login");
  //     }
  //   };

  //   checkSession();
  // }, [navigate]);

  const handleResetPassword = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/auth/reset-password`,
      });

      if (error) throw error;

      setResetSent(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen bg-gray-50 pt-8">
      <div className="flex flex-1 items-center justify-center p-8">
        <div className="w-full max-w-md">
          <div className="mb-6 text-center">
            <div className="mb-3 inline-flex size-14 items-center justify-center rounded-full bg-gradient-to-br from-vincer-500 to-vincer-400">
              <Zap className="size-8 text-white" />
            </div>
            <h1 className="mb-2 text-3xl font-bold text-gray-900">
              Reset Your Password
            </h1>
            <p className="text-gray-600">
              Enter your email to reset your password.
            </p>
          </div>

          {resetSent ? (
            <div className="rounded-xl border bg-white p-6 shadow-sm">
              <div className="rounded-lg border border-green-200 bg-green-50 px-4 py-3 text-sm text-green-700 mb-4">
                An email has been sent to {email} with instructions to reset
                your password.
              </div>
              <Button className="w-full">
                <a href="/auth/login">Back to login</a>
              </Button>
            </div>
          ) : (
            <form
              onSubmit={handleResetPassword}
              className="space-y-4 rounded-xl border bg-white p-6 shadow-sm"
            >
              {error && (
                <div className="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
                  {error}
                </div>
              )}

              <div className="space-y-2">
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-700"
                >
                  Email
                </label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="block w-full rounded-lg border border-gray-300 px-3 py-2 shadow-sm placeholder:text-gray-400 focus:border-vincer-500 focus:outline-none focus:ring-vincer-500 sm:text-sm"
                  placeholder="New password"
                />
              </div>

              <Button type="submit" disabled={loading} className="w-full">
                {loading ? "Sending Email..." : "Send Email"}
              </Button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
